<template>
  <div class="tr">
    <div class="td flex-col capitalize items-start" style="flex-grow: 2">
      <div class="flex justify-between items-center w-full">
        <div class="flex flex-col">
          <span class="font-bold text-left">
            {{ good.harp_description }} {{ good.harp_config_description }}
          </span>
          <span class="flex">
           #{{ good.serial_no }}
          </span>
              <span class="mt-4">
            Purchased on: {{ good.sales_date }}
          </span>
        </div>
        <button class="px-2 py-1 rounded-full bg-green-400 text-white cursor-pointer"
                @click="getSerialInformation"
                v-if="good.harp_model === 'ND'"
        >
          <i class="fas fa-sync-alt"></i>
        </button>
      </div>

    </div>
    <div class="td flex-col capitalize items-start" style="flex-grow: 2">
      <span class="font-bold text-left">
        {{ good.customer.company }}
      </span>
      <span>
        {{ good.customer.address1 }}
      </span>
      <span>
        {{ good.customer.postcode }} {{ good.customer.city }} ({{ good.customer.country }})
      </span>
      <span>
        {{ good.customer.email }}
      </span>
    </div>
    <div class="td flex-col capitalize items-start"
         style="flex-grow: 2"
         v-if="good.dealer"
    >
      <span class="font-bold text-left">
        {{ good.dealer.company }}
      </span>
      <span>
        {{ good.dealer.address1 }}
      </span>
      <span>
        {{ good.dealer.postcode }} {{ good.dealer.city }} ({{ good.dealer.country }})
      </span>
      <span>
        {{ good.dealer.email }}
      </span>
    </div>
    <div class="td flex-col capitalize items-start"
         style="flex-grow: 2"
         v-if="good.dealer_name"
    >
      <span class="font-bold text-left">
        {{ good.dealer_name }}
      </span>
    </div>
    <div class="td flex-col capitalize justify-center">
      <span class="font-bold text-xl px-4">
        {{ good.end_warranty_date }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['good'],

  data() {
    return {
      serialInfo: {},
    }
  },

  methods: {
    getSerialInformation() {
      axios({
        method: 'get',
        url: `https://bees.salviharps.com/api/vendite/beni/${this.good.serial_no}`,
        headers: {
          accept: 'application/json',
          Authorization: `Bearer QwVEaRk6fgQFZ0j9uzTknIb29n9qH6Sw5B5GLUv9STucQ4HzX2KolkRnZkp3`,
        },
      }).then(({ data }) => {
        if (data === 'Arpa Non Trovata') {
          this.$toastr.e('Non sono riuscito a trovare l\'arpa');
          return;
        }
        this.serialInfo = data.data[0];

        swal.fire({
          title: 'Ho trovato un\'Arpa! Vuoi aggiornare la garanzia?',
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: `Yes`,
          denyButtonText: `No`,
        }).then((result) => {
          if (result.isConfirmed) {
            this.updateWarranty();
          } else if (result.isDenied) {
            Swal.fire('Aggiornato niente', '', 'info')
          }
        })
      });
    },
    updateWarranty() {
      let payload = {
        harp_model: this.serialInfo.cod_articolo,
        harp_description: this.serialInfo.des_articolo,
        harp_config: this.serialInfo.cod_config,
        harp_config_description: this.serialInfo.des_config,
      };

      axios.put(`/warranty/goods/${this.good.id}`, payload)
        .then(() => {
          this.$toastr.s('Garanzia Aggiornata');
          this.$emit('good-updated');
        })
    }
  }
}
</script>

<style scoped>

</style>